import { literal, object, string } from 'superstruct';

import { ListResourceDto } from '@adflow/shared/util-data';
import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import { AddMediaDto } from './add-media.dto';
import { EditMediaDto } from './edit-media.dto';
import { ListMediaQueryDto } from './list-media-query.dto';
import { ViewMediaDto } from './view-media.dto';

const p = adflowApiSchema.prefix('media/google-my-business');

export const ListGMBMedias = p.get('', {
	req: object({
		query: ListMediaQueryDto,
	}),
	res: ListResourceDto(ViewMediaDto),
});

export const GetGMBMedia = p.get(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: ViewMediaDto,
});

export const AddGMBMedia = p.post('', {
	req: object({
		body: AddMediaDto,
	}),
	res: object({
		file: ViewMediaDto,
		signedUrl: string(),
	}),
});

export const ProcessGMBMedia = p.post(':mediaId/process', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: ViewMediaDto,
});

export const EditGMBMedia = p.patch(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
		body: EditMediaDto,
	}),
	res: ViewMediaDto,
});

// export const ArchiveGoogleAdsMedia = p.delete(':mediaId', {
// 	req: object({
// 		params: object({ mediaId: parsableInteger() }),
// 	}),
// 	res: literal(undefined),
// });

export const DeleteGMBMedia = p.delete(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: literal(undefined),
});
